<script lang="ts">
    import { type LoginError, postLogin, reloadBookmarks } from "../../api"
    import { location, newNotification, removeNotification } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { _ } from "svelte-i18n"
    import { navigateTo } from "../../helper"
    import { initialLocale } from "../../i18n"

    export let lang = "de"

    let username = ""
    let password = ""
    let mfaToken = ""
    let mfaCode = ""
    let loading = false

    $: redirectTo = new URLSearchParams($location.search).get("redirectTo")

    let loginNotification: NotificationEntry

    function submitLogin() {
        removeNotification(loginNotification)

        loading = true

        postLogin({ username, password, mfaToken, mfaCode })
            .then((login) => {
                newNotification({
                    class: "success",
                    html: $_("login.successNotification"),
                })
                reloadBookmarks()
                if (redirectTo) {
                    navigateTo(redirectTo, { replace: true })
                } else {
                    navigateTo("/", { replace: true })
                }
            })
            .catch((e: LoginError) => {
                console.error(e, e.data)
                if (e.type == "fail") {
                    loginNotification = newNotification({
                        class: "error",
                        html: $_("login.failNotification"),
                        timeout: 5000,
                        removeOnNewLocation: true,
                    })
                    username = ""
                    password = ""
                    mfaCode = ""
                    mfaToken = ""
                } else if (e.type == "mfa") {
                    loginNotification = newNotification({
                        class: "info",
                        html: $_("login.mfaNotification"),
                        timeout: 5000,
                        removeOnNewLocation: true,
                    })

                    mfaToken = e.data?.mfaToken
                    username = ""
                    password = ""
                } else {
                    loginNotification = newNotification({
                        class: "error",
                        html: $_("login.unknownErrorNotification"),
                        timeout: 5000,
                        removeOnNewLocation: true,
                    })
                    username = ""
                    password = ""
                    mfaCode = ""
                    mfaToken = ""
                }
            })
            .finally(() => {
                loading = false
            })
    }
</script>

<section id="login" class="section_padding" data-lang="{lang}">
    <div class="container">
        <h1>{$_("login.login")}</h1>
        <form on:submit|preventDefault="{submitLogin}">
            {#if mfaToken}
                <div class="row">
                    <div class="col-md-12">{$_("login.enterMfaCode")}</div>
                    <div class="col-md-6">
                        <input type="text" placeholder="{$_('login.code')}" bind:value="{mfaCode}" required />
                    </div>
                    <div class="col-md-6 flexstart">
                        {#if loading}
                            <MiniLoader />
                        {:else}
                            <button class="btn" type="submit">{$_("login.submitButton")}</button>
                        {/if}
                    </div>
                </div>
            {:else}
                <div class="row">
                    <div class="col-md-6">
                        <input
                            type="text"
                            placeholder="{$_('login.usernamePlaceholder')}"
                            bind:value="{username}"
                            required
                            name="username"
                        />
                    </div>
                    <div class="col-md-6">
                        <input
                            type="password"
                            placeholder="{$_('login.passwordPlaceholder')}"
                            bind:value="{password}"
                            required
                            class="sentry-mask"
                            name="password"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 flexstart">
                        <ul class="pw_nav">
                            <li>
                                <a href="/{initialLocale}/account-pw-reset">{$_("login.resetPassword")}</a>
                            </li>
                            <li>
                                <a href="/{initialLocale}/account-request">{$_("login.requestAccess")}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-6 flexend">
                        {#if loading}
                            <MiniLoader />
                        {:else}
                            <button class="btn" type="submit">{$_("login.submitButton")}</button>
                        {/if}
                    </div>
                </div>
            {/if}
        </form>
    </div>
</section>
